import React, { useEffect } from 'react'
import ScreenWrapper from '~/components/screen_wrappers/screen_wrapper'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getNotification as getNotificationSelector, getNotificationsIsLoading } from '@verzekeringapp-mono/shared/src/state/selectors/notifications'
import { useParams } from 'react-router-dom'
import { format } from 'date-fns'
import useNotification from '@verzekeringapp-mono/shared/src/hooks/use_notification'

const NotificationDetailScreen: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const notification = useAppSelector(getNotificationSelector())
  const isLoading = useAppSelector(getNotificationsIsLoading)
  const { getNotification } = useNotification()

  useEffect(() => {
    getNotification(id ?? '')
  }, [])

  if (!notification && !isLoading) {
    return (
      <ScreenWrapper
        breadCrumbsOverride={[
          { path: '/notificaties', label: 'Notificaties' },
          { path: `/notificaties/${id}`, label: 'Notificatie' }
        ]}
      >
        <div className='flex justify-center items-center h-full'>
          <p className='paragraph-light'>Notificatie niet gevonden.</p>
        </div>
      </ScreenWrapper>
    )
  }

  if (isLoading && !notification) {
    return (
      <ScreenWrapper
        breadCrumbsOverride={[
          { path: '/notificaties', label: 'Notificaties' },
          { path: `/notificaties/${id}`, label: 'Notificatie' }
        ]}
      >
        <div className='flex justify-center items-center h-full'>
          <p className='paragraph-light'>Laden...</p>
        </div>
      </ScreenWrapper>
    )
  }

  return (
    <ScreenWrapper
      breadCrumbsOverride={[
        {
          path: '/notificaties',
          label: 'Notificaties'
        },
        {
          path: `/notificaties/${notification?.id}`,
          label: 'Notificatie'
        }
      ]}
    >
      <div className='h-full rounded bg-surface-page p-8'>
        <p className='description-bold'>{notification?.title}</p>

        <div
          className='mt-2 html-content'
          dangerouslySetInnerHTML={{ __html: notification?.message ?? '' }}
        />

        <p className='mt-2 paragraph-light'>
          {notification?.startDate ? format(new Date(notification?.startDate), 'dd-MM-yyyy') : ''}
        </p>
      </div>
    </ScreenWrapper>
  )
}

export default NotificationDetailScreen
